import { Grid } from '@mui/material';
import { Colors } from '../../../theme/colors';
import { AvatarPlaceHolder } from './avatar.placeholder';
import { BoxPlaceholder } from './box.placeholder';
import { TextPlaceholder } from './text.placeholder';

export function DeliveryCardPlaceholder() {
  return (
    <BoxPlaceholder borderColor={Colors.lightGray} width="450px" height="75px" borderRadius="5px">
      <Grid
        container
        direction="row"
        spacing={1}
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <Grid>
          <Grid container direction="row" spacing={1}>
            <Grid>
              <AvatarPlaceHolder style={{ marginTop: '8px' }} diameter={40} />
            </Grid>
            <Grid>
              <TextPlaceholder width="200px" lineCount={2} />
            </Grid>
          </Grid>
        </Grid>

        <Grid>
          <BoxPlaceholder borderRadius="5px" backgroundColor={Colors.lightGray} width="100px" height="20px" />
        </Grid>
      </Grid>
    </BoxPlaceholder>
  );
}
